import React, { useEffect, useState } from 'react';
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters.png'
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import classes from "../SitesOnSchedule/sitesOnScheduleSearchBar.module.css"

const UserManagementSearchbar = (props) => {
    const { placeholder, onChange, value, showFilterButton, appAdmin, setAppAdmin, portalAdmin, setPortalAdmin } = props;
    const [showFilters, setShowFilters] = useState(false);

    const [roleFilters, setRoleFilters] = useState([])



    useEffect(() => {
        console.log(roleFilters)

        roleFilters.includes('Portal admin') ? setPortalAdmin(1) : setPortalAdmin(0)
        roleFilters.includes('App admin') ? setAppAdmin(1) : setAppAdmin(0)

    }, [roleFilters])

    const handleClear = () => {
        onChange({ target: { value: '' } });
    };

    const handleShowFilters = () => {
        setShowFilters(prev => !prev);
    };

    const HandleResetFilters = () => {
        setRoleFilters([]);
        setShowFilters(false);
    };

    const HandleApplyFilters = () => {
        setShowFilters(false);
    };

    const roleOptions = [
    { label: "Portal admin", value: "Portal admin" },
    { label: "App admin", value: "App admin" }
  ];

    return (
        <>
            <div className={classes.searchContainer}>
                <input 
                    className={classes.searchBar}
                    placeholder={placeholder}
                    onChange={onChange}
                    value={value}
                />
                <div className={classes.buttonGroup}>
                    {value && (
                        <button 
                            className={classes.clearButton} onClick={handleClear} type="button">
                                x
                        </button>
                    )}
                    {showFilterButton && <button className={classes.filterButton} onClick={handleShowFilters} type="button" >
                            <img style={{ height: '30px', width: '30px' }} src={filters} />
                        </button>
                    }
                </div>
                {showFilters && (
                    <div className={classes.filterDropdown}>
                            <div className={classes.filterRow}>
                                <label style={{ marginBottom: "5px" }} className={classes.filterLabel}>Access level:</label>
                                <MultiSelect
                                    value={roleFilters}
                                    options={roleOptions}
                                    onChange={(e) => setRoleFilters(e.value)}
                                    placeholder="Choose access"
                                    style={{ width: "400px", marginBottom: "10px" }} 
                                />

                            </div>

                            <div className={classes.buttonRow}>
                                <Button type="button" style={{ marginRight: "15px" }} label="Reset filter" onClick={HandleResetFilters} outlined severity='danger' />
                                <Button type="button" label="Apply" onClick={HandleApplyFilters} />
                            </div>  
                    </div> 
                )}
            </div>
        </>
    );
}

export default UserManagementSearchbar;